import { render } from "./TableHeader.vue?vue&type=template&id=e78e7554&scoped=true&ts=true"
import script from "./TableHeader.vue?vue&type=script&lang=ts"
export * from "./TableHeader.vue?vue&type=script&lang=ts"

import "./table-header.scss?vue&type=style&index=0&id=e78e7554&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e78e7554"]])

export default __exports__